import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import Cookies from "js-cookie";

let CookiePolicyOptions = {
  cookie: "CT_CookiePolicyAccepted",
  expires: 1826,
  classes: {
    show: "show"
  }
};

class CookiePolicy extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(CookiePolicyOptions, options);
    if (!Cookies.get(this.options.cookie)) {
      this.setUpEvents();
      this.show();
    }
  }

  setUpEvents() {
    var self = this;
    this.element.find("button").on("click", function(evt) {
      evt.preventDefault();
      self.writeCookie();
      self.hide();
    });
  }

  writeCookie() {
    Cookies.set(this.options.cookie, true, {
      path: "/",
      expires: this.options.expires
    });
  }

  hide() {
    this.element.removeClass(this.options.classes.show);
  }

  show() {
    this.element.addClass(this.options.classes.show);
  }
}

export { CookiePolicy };



// WEBPACK FOOTER //
// ./Javascript/core/classes/cookiepolicy.class.js